{
  "__review_clinicalData": "Backend/clinician-authored API data (allergen/medication/problem/provider/result names, values, units, ranges, comments, message bodies) — Phase 9, do not translate",
  "enums": {
    "appointmentStatus": {
      "scheduled": "예약됨",
      "confirmed": "확인됨",
      "completed": "완료됨",
      "cancelled": "취소됨",
      "no-show": "미방문",
      "checked-in": "접수 완료"
    },
    "resultStatus": {
      "final": "최종",
      "preliminary": "예비",
      "corrected": "정정됨"
    },
    "allergySeverity": {
      "severe": "심함",
      "high": "높음",
      "moderate": "보통"
    },
    "nationalIdType": {
      "NRIC": "NRIC (싱가포르 신분증)",
      "HKID": "HKID (홍콩 신분증)",
      "MyKad": "MyKad (말레이시아 신분증)",
      "Aadhaar": "Aadhaar (인도 신분증)",
      "KTP": "KTP (인도네시아 신분증)",
      "Passport": "여권"
    },
    "messageSenderType": {
      "provider": "의료진",
      "patient": "환자"
    }
  },
  "form": {
    "validation": {
      "passwordMismatch": "비밀번호가 일치하지 않습니다",
      "passwordMinLength": "비밀번호는 8자 이상이어야 합니다"
    }
  },
  "labels": {
    "abnormal": "비정상"
  },
  "pages": {
    "layout": {
      "nav": {
        "myHealth": "내 건강",
        "results": "검사 결과",
        "appointments": "예약",
        "messages": "메시지",
        "forms": "양식"
      },
      "signOut": "로그아웃",
      "signOutAria": "로그아웃",
      "navAria": "포털 탐색",
      "footer": "VynaEMR 환자 포털 — FLOSTEL Healthcare IT"
    },
    "login": {
      "subtitle": "환자 포털",
      "labels": {
        "email": "이메일",
        "password": "비밀번호"
      },
      "placeholders": {
        "email": "you@example.com",
        "password": "비밀번호를 입력하세요"
      },
      "button": {
        "signIn": "로그인",
        "signingIn": "로그인 중..."
      },
      "toast": {
        "welcome": "다시 오신 것을 환영합니다!",
        "invalid": "이메일 또는 비밀번호가 올바르지 않습니다"
      },
      "links": {
        "noAccount": "계정이 없으신가요?",
        "register": "회원가입"
      }
    },
    "dashboard": {
      "greeting": {
        "morning": "좋은 아침입니다",
        "afternoon": "안녕하세요",
        "evening": "좋은 저녁입니다",
        "fallbackName": "환자님"
      },
      "subtitle": "건강 요약을 확인하세요.",
      "error": "건강 요약을 불러올 수 없습니다. 잠시 후 다시 시도해 주세요.",
      "demographics": {
        "ageLabel": "{{age}}세",
        "bloodTypeLabel": "혈액형: {{bloodType}}"
      },
      "quickLinks": {
        "results": "검사 결과",
        "appointments": "예약",
        "messages": "메시지",
        "forms": "양식"
      },
      "sections": {
        "allergies": "알레르기",
        "activeMedications": "복용 중인 약물",
        "activeProblems": "현재 건강 문제",
        "upcomingAppointments": "예정된 예약",
        "recentResults": "최근 결과",
        "immunizations": "예방접종 기록",
        "emergencyContact": "비상 연락처"
      },
      "states": {
        "noAllergies": "등록된 알레르기가 없습니다.",
        "noMedications": "복용 중인 약물이 없습니다.",
        "noAppointments": "예정된 예약이 없습니다.",
        "noResults": "최근 결과가 없습니다."
      },
      "moreCount": "외 {{count}}건",
      "sinceDate": "{{date}}부터",
      "doseNumber": "{{number}}차 접종",
      "viewAll": "모두 보기",
      "providerTBD": "담당 의료진 미정"
    },
    "register": {
      "subtitle": "계정 만들기",
      "labels": {
        "fullName": "이름",
        "email": "이메일",
        "dateOfBirth": "생년월일",
        "phone": "전화번호",
        "mrn": "MRN (의무기록 번호)",
        "idType": "신분증 종류",
        "idNumber": "신분증 번호",
        "password": "비밀번호",
        "confirmPassword": "비밀번호 확인"
      },
      "placeholders": {
        "fullName": "이름을 입력하세요",
        "email": "you@example.com",
        "phone": "+65 9123 4567",
        "mrn": "e.g. P0000000001",
        "idNumber": "신분증 번호를 입력하세요",
        "password": "8자 이상",
        "confirmPassword": "비밀번호를 다시 입력하세요",
        "selectIdType": "선택하세요..."
      },
      "mrnHint": "계정을 의무기록과 연결하려면 MRN 또는 신분증 번호를 입력하세요.",
      "button": {
        "createAccount": "계정 만들기",
        "creatingAccount": "계정을 만드는 중..."
      },
      "toast": {
        "success": "회원가입이 완료되었습니다. 로그인해 주세요.",
        "failure": "회원가입에 실패했습니다. 다시 시도해 주세요."
      },
      "links": {
        "haveAccount": "이미 계정이 있으신가요?",
        "signIn": "로그인"
      },
      "aria": {
        "dateOfBirth": "생년월일"
      }
    },
    "appointments": {
      "title": "예약",
      "subtitle": "예약을 확인하고 관리하세요",
      "error": "예약을 불러올 수 없습니다. 잠시 후 다시 시도해 주세요.",
      "sections": {
        "upcoming": "예정된 예약",
        "past": "지난 예약"
      },
      "states": {
        "noUpcoming": "예정된 예약이 없습니다.",
        "noPast": "지난 예약이 없습니다."
      },
      "reasonLabel": "사유: {{reason}}",
      "instructionsLabel": "안내 사항: {{instructions}}",
      "durationMinutes": "{{minutes}}분",
      "actions": {
        "cancel": "취소",
        "confirmCancel": "확인",
        "cancelling": "취소하는 중...",
        "keep": "유지"
      },
      "toast": {
        "cancelSubmitted": "취소 요청이 접수되었습니다. 진료팀이 확인 후 안내드립니다.",
        "cancelFailed": "예약을 취소하지 못했습니다. 진료실로 전화해 주세요."
      }
    },
    "results": {
      "title": "검사 결과",
      "subtitle": "검사 및 영상 결과를 확인하세요",
      "error": "결과를 불러올 수 없습니다. 잠시 후 다시 시도해 주세요.",
      "referenceRange": "(참고치: {{range}})",
      "states": {
        "noResults": "확인할 수 있는 결과가 없습니다."
      }
    },
    "messages": {
      "title": "메시지",
      "subtitle": "의료팀과 소통하세요",
      "error": "메시지를 불러올 수 없습니다. 잠시 후 다시 시도해 주세요.",
      "fromSender": "보낸 사람: {{name}}",
      "labels": {
        "subject": "제목",
        "message": "메시지",
        "reply": "답장"
      },
      "placeholders": {
        "subject": "메시지 제목",
        "message": "메시지를 입력하세요...",
        "reply": "답장을 입력하세요..."
      },
      "actions": {
        "newMessage": "새 메시지",
        "back": "메시지 목록으로 돌아가기",
        "sendMessage": "메시지 보내기",
        "sendReply": "답장 보내기",
        "sending": "보내는 중..."
      },
      "states": {
        "noMessages": "아직 메시지가 없습니다."
      },
      "thread": {
        "fromSenderWithType": "보낸 사람: {{name}} ({{type}})"
      },
      "compose": {
        "title": "새 메시지",
        "subtitle": "메시지가 의료팀에 전송됩니다."
      },
      "toast": {
        "sent": "메시지를 보냈습니다",
        "sendFailed": "메시지 전송에 실패했습니다"
      }
    },
    "forms": {
      "title": "양식",
      "subtitle": "필수 양식과 설문지를 작성하세요",
      "error": "양식을 불러올 수 없습니다. 잠시 후 다시 시도해 주세요.",
      "sections": {
        "pending": "미제출",
        "completed": "제출 완료"
      },
      "labels": {
        "required": "필수"
      },
      "placeholders": {
        "select": "선택하세요..."
      },
      "actions": {
        "fillOut": "작성하기",
        "back": "양식 목록으로 돌아가기",
        "submit": "양식 제출",
        "submitting": "제출 중..."
      },
      "states": {
        "noPending": "미제출 양식이 없습니다.",
        "noCompleted": "제출 완료된 양식이 없습니다.",
        "noFields": "이 양식에는 작성할 항목이 없습니다."
      },
      "toast": {
        "submitted": "양식이 성공적으로 제출되었습니다",
        "submitFailed": "양식 제출에 실패했습니다"
      }
    }
  }
}
